function initLoadmoreNewsAndMasonery(){
    $('body').on('click','.om-news-lazyload',function () {
        var trigger = $(this);
        trigger.addClass('active');
        var pointer = $(this).data('omnews-offset');
        var numberOfItemsToLoad = $(this).data('omnews-itemload');
        var type = $(this).data('omnews-type');

        ajaxArtikel(pointer,numberOfItemsToLoad,type).then(function (data) {
            //done
            trigger.removeClass('active');
            trigger.data('omnews-offset',pointer + numberOfItemsToLoad);
            var listContainer = trigger.prev();
            var items = $(data).find('.om-news-list .om-news-list__item');
            items.addClass('msry-hide');
            listContainer.append(items);
            listContainer.masonry('appended', items);
            items.each(function(fadeInDiv){
                var ele = $(this);
                setTimeout(function() {
                    ele.removeClass('msry-hide');
                }, fadeInDiv * 500);

            });
            //disable reaload button when we receive fewer then requested items
            //for ie
            //picturefill();
            if($(data).find('.om-news-list .om-news-list__item').length < numberOfItemsToLoad){
                trigger.fadeOut();
            }
        }, function () {
            trigger.removeClass('active');
            //error
            alert('Es gab einen Fehler beim nachladen')
        })
    })
}

function ajaxArtikel(pointer,numberOfItemsToLoad,type) {
    return $.ajax({
        cache:false,
        url:location.protocol+'//'+window.location.host,
        data:{
            type:1720,
            pointer:pointer,
            load:numberOfItemsToLoad,
            itemType:type,
        },
    })
}